import {
  ArrayField,
  BooleanField,
  BooleanInput,
  Button,
  Create,
  CreateButton,
  Datagrid,
  DateField,
  DeleteWithConfirmButton,
  EditButton,
  email,
  FieldProps,
  Form,
  FormDataConsumer,
  ImageField,
  Link,
  ReferenceArrayInput,
  ReferenceField,
  required,
  SaveButton,
  SimpleForm,
  TextField,
  TextInput,
  Toolbar,
  useGetIdentity,
  useLocaleState,
  useNotify,
  useRecordContext,
  useRedirect,
  useRefresh,
  useTranslate,
  SingleFieldList,
  ReferenceInput,
  useChoicesContext,
} from 'react-admin';
import { canAccess } from '@react-admin/ra-rbac';
import * as React from 'react';
import {
  Dispatch,
  SetStateAction, useEffect, useMemo, useState,
} from 'react';
import {
  FieldValues, useFormContext, useFormState,
} from 'react-hook-form';
import {
  Button as MuiButton,
  Checkbox,
  InputLabel, Tooltip,
  Typography,
  CardContent,
  Stack,
  Chip,
} from '@mui/material';
import _, { get } from 'lodash';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CircularProgress from '@mui/material/CircularProgress';
import LoopIcon from '@mui/icons-material/Loop';
import {
  Asset, CertificationCategory, CertificationProperties, CustomerUserRelation, User,
} from '@x-guard/xgac-types/xgac';
import Grid2 from '@mui/material/Unstable_Grid2';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import queryString from 'query-string';
import { ReferenceOneInput } from '@react-admin/ra-relationships';
import moment from 'moment';
import { useGetList, useGetMany, usePermissions } from 'ra-core';
import { ListLive } from '@react-admin/ra-realtime';
import SearchFields from '../components/fields/Filters';
import { DocumentaryProofField, DocumentaryProofInputPreview } from '../components/DocumentaryProof';
import { LIST_DEBOUNCE, XGAC_MAIN_API_URL } from '../../../config';
import { xgacDataProvider } from '../../../dataProviders/xgacDataProvider';
import { StyledButton } from '../buttons/StyledButton';
import { httpClient } from '../../../utils/httpClient';
import { EditWithSuccess } from '../../../components/baseForms/EditWithSuccess';
import { CreateWithSuccess } from '../../../components/baseForms/CreateWithSuccess';
import ReferenceFieldNullable from '../../../components/fields/ReferenceFieldNullable';
import { GrayTextInputWithUpperLabel } from '../components/inputs/GrayTextInputWithUpperLabel';
import { BooleanCheckBoxInput } from '../components/inputs/BooleanCheckBoxInput';
import { refreshContext } from '../../../utils/authProvider';
import { PhoneNumberInput } from '../../../components/inputs/PhoneNumberInput';
import { UsernameInput } from '../components/inputs/UsernameInput';
import { ResetPasswordButton } from '../../../components/buttons/ResetPasswordButtons';
import { RegistrationCodePicker } from '../../../components/RegistrationCodePicker';
import { getCurrentCustomer } from '../../../lib/currentCustomer';
import ReferenceArrayFieldNullable from '../../../components/fields/ReferenceArrayFieldNullable';
import { AvatarPictureField } from '../../../components/fields/AvatarPictureField';
import { TwoFactorButton } from '../../../components/buttons/TwoFactorButton';
import { ImageInput } from '../../../components/inputs/ImageInput';
import { GrayDateInputWithUpperLabel } from '../components/inputs/GrayDateInputWithUpperLabel';
import { GrayAutocompleteInputWithUpperLabel } from '../components/inputs/GrayAutocompleteInputWithUpperLabel';
import { GrayAutocompleteArrayInputWithUpperLabel } from '../components/inputs/GrayAutocompleteArrayInputWithUpperLabel';
import { CertificationExpiryWithDaysCaption } from '../../../components/CertificationExpiryWithDaysCaption';
import { ExpiryDateDisplay } from '../components/ExpiryDateDisplay';
import {
  calculateDaysUntilExpiry, certificationExpiryChipColor, getCertificationExpiryText,
} from '../../../utils/certificationsAndItemsExpiry';
import { CertificationDocumentInput } from '../components/inputs/CertificationDocumentInput';
import { RenewalChoiceDialog } from '../components/RenewalChoiceDialog';
import { PlanRenewalModal } from '../components/PlanRenewalModal';
import { RenewNowModal } from '../components/RenewNowModal';
import DateFieldNullable from '../../../components/fields/DateFieldNullable';
import { PlannedRenewalDateInputField } from '../components/inputs/PlannedRenewalDateInputField';

const apiUrl = XGAC_MAIN_API_URL;

const Grid = Grid2;
const assetUserTransformer = (asset: any) => {

  return {
    ...asset,
    available: asset.available || false,
    username: asset.username || asset.properties.email,
    properties: {
      ...asset.properties,
      smsNumber: asset.properties?.phoneNumber,
      locale: asset.properties?.locale || 'nl',
    },
  };

};

const assetUserEditTransformer = (asset: any) => {

  if (asset.assetGroups) {

    asset.assetGroups = asset.assetGroups.map((group: any) => {

      return {
        _id: group,
        _ref: 'AssetGroup',
      };

    });

  }
  if (asset.properties?.image === null) {

    delete asset.properties.image;

  }
  return {
    ...asset,
    properties: {
      ...asset.properties,
      smsNumber: asset.properties?.phoneNumber,
      locale: asset.properties?.locale || 'nl',
    },
  };

};

const BooleanSetterField = (props: {
  label: string;
  source: string;
  lastUpdated: Date | null;
  setLastUpdated: Dispatch<SetStateAction<Date | null>>;
}) => {

  const refresh = useRefresh();
  const record = useRecordContext();
  const initialValue = get(record, props.source);
  const translate = useTranslate();
  const [value, setValue] = useState(initialValue);
  const [isSaving, setIsSaving] = useState(false);
  const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {

    if (!record) {

      return;

    }
    if (props.source === 'isAdmin') {

      return;

    }
    setIsSaving(true);
    setValue(event.target.checked);
    const patchData = {
      [props.source]: event.target.checked,
    };
    await xgacDataProvider.update('assets', { id: record.id, data: patchData, previousData: record });
    setIsSaving(false);
    refresh();

  };
  useEffect(() => {

    const newValue = get(record, props.source);
    if (newValue !== value) {

      setValue(newValue);

    }
    if (record) {

      if (!props.lastUpdated) {

        props.setLastUpdated(new Date(record.updatedAt));
        return;

      }
      if (new Date(record.updatedAt) > props.lastUpdated) {

        props.setLastUpdated(new Date(record.updatedAt));

      }

    }

  }, [record]); // eslint-disable-line react-hooks/exhaustive-deps

  if (isSaving) {

    return (
      <>
        <CircularProgress size={20}/>
      </>
    );

  }

  if (props.source === 'available' && !record?.properties.phoneNumber) {

    return (
      <>
        <Checkbox checked={false} sx={{ paddingLeft: 0 }} disabled={true} />
        {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
        {/* @ts-ignore */}
        <EditButton label="resources.app-users.text.fill_phonenumber" color="warning" icon={false} resource="assets"/>
      </>
    );

  }

  return (
    <>
      <Checkbox checked={value} sx={{ paddingLeft: 0 }} onChange={handleChange} />
      <span>{translate(value ? 'general.text.yes' : 'general.text.no')}</span>
    </>
  );

};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const IsAdminBooleanSetterField = (props: FieldProps & { changeHandler?: any }) => {

  const record = useRecordContext();
  const refresh = useRefresh();
  const [relation, setRelation] = useState<CustomerUserRelation | null>(null);
  const [value, setValue] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const loggedInUserId = useGetIdentity().data?.id;
  const disabled = !record || !record.user?._id || record.user?._id === loggedInUserId;
  const translate = useTranslate();

  useEffect(() => {

    if (!relation && record?.user?._id && !disabled && record.customer?._id) {

      const getRelation = async () => {

        setIsSaving(true);

        const relationRequest = await httpClient(`${apiUrl}/customer-user-relations?${queryString.stringify({
          'user._id': record.user._id,
          'customer._id': record.customer._id,
        })}`);

        setRelation(relationRequest.json?.result[0] || null);
        const rolesHasBhvkOrAdmin = ['bhvk_admin', 'bhvk_trial'].some((role: string) => relationRequest.json?.result[0]?.roles.includes(role));
        setValue(rolesHasBhvkOrAdmin);
        setIsSaving(false);

      };
      getRelation();

    }

  }, [disabled, record, relation]);

  const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {

    setIsSaving(true);
    if (!relation) {

      setIsSaving(false);
      return;

    }
    setValue(event.target.checked);
    const patchData = {
      roles: event.target.checked ? [...relation.roles, 'bhvk_admin'] : relation.roles.filter((role: string) => !['bhvk_admin', 'bhvk_trial'].includes(role)),
    };
    const newRelation = await xgacDataProvider.update('customer-user-relations', { id: relation._id, data: patchData, previousData: relation });

    if (event.target.checked) {

      await httpClient(`${apiUrl}/users/reset-password/${relation.user._id}?bhvk=true&admin_role_assigned=true`);

    }
    setRelation(newRelation.data);
    setIsSaving(false);
    refresh();

    if (props.changeHandler) {

      props.changeHandler();

    }

  };

  if (isSaving) {

    return (
      <>
        <CircularProgress size={20}/>
      </>
    );

  }

  return (
    <>
      <Checkbox checked={value} onChange={handleChange} sx={{ paddingLeft: 0 }} disabled={disabled}/>
      <span>{translate(value ? 'general.text.yes' : 'general.text.no')}</span>
    </>
  );

};

const AssetActions = () => {

  const redirect = useRedirect();
  const translate = useTranslate();
  return (
    <>
      <StyledButton
        onClick={() => {

          redirect('/help/de-app/hoe-installeer-je-de-bhv-knop-nl-app/');

        }}
        label="general.text.install_app"
        sx={{
          whiteSpace: 'nowrap', paddingLeft: '30px', paddingRight: '30px', marginBottom: '5px', marginRight: '10px',
        }}
        color="primary"
      />
      <>
        <MuiButton
          variant={'contained'}
          color={'secondary'}
          size={'small'}
          component={Link}
          to={{
            pathname: '/assets/create',
          }}
          sx={{
            whiteSpace: 'nowrap', paddingLeft: '30px', paddingRight: '30px', marginBottom: '5px',
          }}
          disabled={false}
        >
          {translate('resources.assets.text.add_user')}
        </MuiButton>
      </>
    </>
  );

};

const AssetCounters = (props: {
  lastUpdated: Date | null;
  customerId: string;
}) => {

  const translate = useTranslate();

  const [availableCount, setAvailableCount] = useState(0);
  const [expiringCertificationsCount, setExpiringCertificationsCount] = useState(0);
  const [lastSavedCustomer, setLastSavedCustomer] = useState<string | null>(null);
  const identity = useGetIdentity();
  const currentCustomer = getCurrentCustomer()?.value;

  useEffect(() => {

    if (currentCustomer && currentCustomer !== lastSavedCustomer) {

      setLastSavedCustomer(currentCustomer);

    }

  }, [identity, currentCustomer]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {

    xgacDataProvider.getList(
      'all-assets',
      {
        pagination: { page: 1, perPage: 1 },
        filter: { available: true, 'user._ref': 'User', 'properties.phoneNumber': '!null' },
        sort: { field: 'name', order: 'ASC' },
      },
    ).then((response) => {

      setAvailableCount(response.total || 0);

    });

  }, [lastSavedCustomer, props.lastUpdated]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {

    xgacDataProvider
      .getExpiringCertificationsCountPerCustomer(props.customerId)
      .then(({ json }: { json: number }) => {

        setExpiringCertificationsCount(Number(json));

      });

  }, [props.customerId]);

  return <div style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
    <div className="assetCounter-card">
      <Typography variant="h4" gutterBottom>
        {availableCount}
      </Typography>
      <Typography variant="caption" gutterBottom>
        {translate('resources.assets.text.number_of_available_users')}
      </Typography>
    </div>
    <div className="assetCounter-card">
      <Typography variant="h4" gutterBottom>
        {expiringCertificationsCount}
      </Typography>
      <Typography variant="caption" gutterBottom>
        {translate('resources.assets.text.number_of_expiring_certifications')}
      </Typography>
    </div>
  </div>;

};

const AssetHasAppField = (props: FieldProps) => {

  const record = useRecordContext();
  if (!record) {

    return null;

  }
  const lastObservationAt = record.lastObservationAt;
  if (!lastObservationAt) {

    return <BooleanField record={{ source: false }} source="source" label={props.label} />;

  }
  const onlineThreshold = moment(record.lastObservationAt).add(1, 'week');

  const isApp = moment.utc().isBefore(onlineThreshold);
  return <BooleanField record={{ source: isApp }} source="source" label={props.label} />;

};

const getExpiringDaysByCategoryId = (asset: Asset) => {

  const result: Record<string, number> = {};
  for (const certification of asset.certifications ?? []) {

    const categoryId = certification.certificationCategory?._id;
    if (!categoryId || !certification.expiryDate) continue;
    result[categoryId] = calculateDaysUntilExpiry(certification.expiryDate);

  }
  return result;

};

const CategoryChip = ({ expiringDaysByCategoryId }: { expiringDaysByCategoryId?: Record<string, number> }) => {

  const translate = useTranslate();
  const category = useRecordContext<{ id?: string; _id?: string; name?: string; largestReminderPeriodInDays: number }>();
  if (!category) {

    return null;

  }
  const id = category._id;
  if (!id) return null;

  const days = expiringDaysByCategoryId?.[id];
  if (!category || !id || days === undefined) return null;

  const expiryChipColor = certificationExpiryChipColor(days, category.largestReminderPeriodInDays);
  const tooltip = getCertificationExpiryText(days, translate);

  return (
    <Tooltip title={tooltip}>
      { expiryChipColor === 'warning' || expiryChipColor === 'error'
        ? <span style={{ display: 'inline-flex' }}>
          <Chip
            sx={{
              bgcolor: `${expiryChipColor}.main`,
              color: 'common.white',
              '& .MuiChip-label': { color: 'common.white' },
              '& .MuiChip-icon': { color: 'common.white' },
            }}
            label={category?.name}
            icon={<AccessTimeIcon fontSize='inherit' />}
          />
        </span>
        : <Chip label={category?.name} />
      }
    </Tooltip>
  );

};

// disabled because the label is simply added to display the column name in the datagrid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const CertificationCategoriesCell = (props: { label?: string }) => {

  const asset = useRecordContext<Asset>();
  if (!asset) {

    return null;

  }
  const expiringDaysByCategoryId = getExpiringDaysByCategoryId(asset);

  return (
    <ReferenceArrayFieldNullable source="certificationCategories" reference="certification-categories" label="resources.users.fields.certification_categories">
      <SingleFieldList linkType={false}>
        <CategoryChip expiringDaysByCategoryId={expiringDaysByCategoryId}/>
      </SingleFieldList>
    </ReferenceArrayFieldNullable>
  );

};

export const AssetList = () => {

  const translate = useTranslate();
  const [lastUpdated, setLastUpdated] = useState<Date | null>(null);
  const [lastSavedCustomer, setLastSavedCustomer] = useState<string | null>(null);
  const currentCustomer = getCurrentCustomer()?.value;
  const identity = useGetIdentity();
  const { data } = useGetList('app-users', {
    pagination: { page: 1, perPage: -1 },
    sort: { field: 'name', order: 'ASC' },
    filter: {},
    meta: {
      $select: 'assetGroups',
    },
  });

  useEffect(() => {

    if (currentCustomer && currentCustomer !== lastSavedCustomer) {

      setLastSavedCustomer(currentCustomer);
      setLastUpdated(null);

    }

  }, [identity, currentCustomer]); // eslint-disable-line react-hooks/exhaustive-deps

  const hasGroupsField = useMemo(() => {

    if (!data) {

      return false;

    }
    const groups = data?.map((asset: { assetGroups: string[] }) => asset.assetGroups);
    return !groups.every((group: string[]) => {

      return _.isEqual(group, groups[0]);

    });

  }, [data]);

  return (
    <>
      <h3>{translate('resources.users.text.title')}</h3>
      <p>{translate('resources.users.text.sub_title')}</p>
      {currentCustomer ? (
        <AssetCounters lastUpdated={lastUpdated} customerId={currentCustomer}/>
      ) : null}
      <ListLive actions={<AssetActions/>}
        filters={SearchFields}
        debounce={LIST_DEBOUNCE}
        title="resources.assets.text.without_app_title"
        resource="all-assets"
        filter={{ 'user._ref': 'User', type: '!kiosk' }}
        empty={false}
      >
        <Datagrid rowClick={false} bulkActionButtons={false} resource="assets">
          <AvatarPictureField/>
          <TextField source="name" label="general.fields.name"/>
          <ReferenceFieldNullable source="user._id" reference="users" label="resources.users.fields.username">
            <TextField source="username"/>
          </ReferenceFieldNullable>
          {hasGroupsField && (
            <ReferenceArrayFieldNullable source="assetGroups" reference="asset-groups" label="resources.asset-groups.name"/>
          )}
          <CertificationCategoriesCell label="resources.users.fields.certification_categories"/>
          <IsAdminBooleanSetterField source={''} label="resources.users.text.access_to_dashboard"/>
          <BooleanSetterField label="resources.users.text.receives_alarms" source="available" lastUpdated={lastUpdated} setLastUpdated={setLastUpdated}/>
          <AssetHasAppField source="lastObservationAt" label="resources.assets.fields.has_app"/>
          <EditButton resource="assets" label="general.text.more_settings" />
        </Datagrid>
      </ListLive>
    </>
  );

};

const ResetButtonPreparer = (props: { updatedAt: Date | null }) => {

  const record = useRecordContext();
  const [user, setUser] = useState<User | null>(null);
  const [userRoles, setUserRoles] = useState<string[]>([]);
  useEffect(() => {

    if (!user && record?.user?._id) {

      xgacDataProvider.getOne('users', { id: record.user?._id }).then((response) => {

        setUser(response.data as unknown as User);

      });

    }

  }, [record?.user?._id, user]);
  useEffect(() => {

    if (!record || !record.user?._id) {

      return;

    }
    httpClient(`${apiUrl}/customer-user-relations?${queryString.stringify({ 'user._id': record.user._id })}`).then((response) => {

      if (response?.json.result[0]?.roles) {

        setUserRoles(response.json.result[0].roles);

      }

    });

  }, [record, props.updatedAt]);

  return (
    <>
      {(
        userRoles.includes('admin')
        || userRoles.includes('support_admin')
        || userRoles.includes('sales_admin')
        || userRoles.includes('bhvk_admin')
        || userRoles.includes('bhvk_trial')) ? (
          <ResetPasswordButton user={user} disabled={false} bhvk={true}/>
        ) : (
          <ResetPasswordButton user={user} disabled={true} bhvk={true}/>
        )}

    </>
  );

};

const AssetDeleteButton = () => {

  const notify = useNotify();
  const redirect = useRedirect();
  const loggedInUser = useGetIdentity().data?.id;
  const record = useRecordContext();
  const translate = useTranslate();
  const customMessage = `${translate('ra.action.delete')} ${record?.name}`;

  const onSuccess = () => {

    notify('resources.assets.text.bhvk_deleted');
    redirect('/assets');

  };

  return (
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
    <DeleteWithConfirmButton icon={false}
      variant={'contained'}
      color="warning"
      resource="app-users"
      confirmTitle={customMessage}
      mutationOptions={{ onSuccess }}
      label={'resources.assets.text.delete_user'}
      sx={{ color: 'white', height: 'fit-content', marginTop: '10px' }}
      size="medium" disabled={!record || record.user?._id === loggedInUser}
    />
  );

};

type AssetCertification = NonNullable<Asset['certifications']>[number];

const CertificationListRowActions = (props: {
  assetRecord: Asset;
  onRenew: (certification: AssetCertification & { certificationCategory?: CertificationCategory }) => void;
 }) => {

  const refresh = useRefresh();
  const translate = useTranslate();

  const certificationRecord = useRecordContext<AssetCertification & { certificationCategory?: CertificationCategory }>();
  if (!certificationRecord) {

    return null;

  }

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '0px' }}>
      <EditButton
        resource="user-certifications"
        to={`/assets/${props.assetRecord._id}/certifications/${certificationRecord._id}`}
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        // property is present according to the documentation (see below). works correctly at runtime
        // https://marmelab.com/react-admin/doc/5.6/Edit.html#prefilling-the-form
        state={{
          record: { ...certificationRecord, id: certificationRecord._id },
          assetName: props.assetRecord.name,
        }}
      />
      <Button
        label="resources.assets.certifications.text.renew"
        onClick={() => {

          props.onRenew(certificationRecord);

        }}
        startIcon={<LoopIcon />}
      />
      <DeleteWithConfirmButton
        resource="user-certifications"
        redirect={false}
        record={{ ...certificationRecord, id: certificationRecord._id }}
        mutationOptions={{
          meta: { assetId: props.assetRecord._id },
          onSettled: () => refresh(),
        }}
        successMessage={'resources.assets.certifications.text.certification_deleted'}
        confirmTitle={`${translate('ra.action.delete')} ${translate('resources.assets.certifications.text.title_single').toLowerCase()}`}
      />
    </span>
  );

};

const CertificationExpiryField = ({
  categoriesById,
  label,
}: {
  categoriesById: Map<string, { largestReminderPeriodInDays: number }
  >;
  label?: string;
}) => {

  const certification = useRecordContext<CertificationProperties & { id?: string }>();
  if (!certification?.expiryDate) return null;

  const categoryId = certification.certificationCategory?._id;
  const largestReminderPeriodInDays = categoriesById.get(categoryId ?? '')?.largestReminderPeriodInDays ?? 0;

  return (
    <CertificationExpiryWithDaysCaption
      label={label}
      record={{
        ...certification,
        id: certification.id ?? categoryId,
        largestReminderPeriodInDays,
      }}
    />
  );

};

const userCertificationTransformer = (data: any) => {

  const categoryId = typeof data.certificationCategory === 'string' ? data.certificationCategory : data.certificationCategory?._id;

  return {
    ...data,
    firstIssuedOn: new Date(data.firstIssuedOn).toISOString(),
    lastReceivedOn: new Date(data.lastReceivedOn).toISOString(),
    expiryDate: new Date(data.expiryDate).toISOString(),
    plannedRenewalDate: data.plannedRenewalDate ? new Date(data.plannedRenewalDate).toISOString() : null,
    certificationCategory: {
      _id: categoryId,
      _ref: 'CertificationCategory',
    },
  };

};

const CertificationList = () => {

  const notify = useNotify();
  const refresh = useRefresh();
  const translate = useTranslate();
  const assetRecord = useRecordContext<Asset>();
  const [renewDialogOpen, setRenewDialogOpen] = useState(false);
  const [renewDialogChoice, setRenewDialogChoice] = useState<'renew_now' | 'plan_renewal' | 'closed'>('closed');
  const [renewingCertification, setRenewingCertification] = useState<AssetCertification & { certificationCategory?: CertificationCategory } | null>(null);

  const userCertificationCategoryIds = assetRecord?.certifications?.map((certification) => certification.certificationCategory?._id);

  const { data: userCertificationCategories = [] } = useGetMany('certification-categories', {
    ids: userCertificationCategoryIds ?? [],
  });

  const hasAtLeastOneDocumentaryProof = userCertificationCategories?.some((category) => category.isDocumentaryProofRequired);

  const categoriesById = useMemo(() => new Map(userCertificationCategories.map((category) => [category.id, category])), [userCertificationCategories]);

  if (!assetRecord) {

    return null;

  }

  const closeRenewDialog = () => {

    setRenewDialogOpen(false);
    setRenewDialogChoice('closed');
    setRenewingCertification(null);

  };

  const handleRenewNowSubmit = async (values: {
    lastInspectionDate: string;
    expiryDate: string;
    document?: { rawFile?: File };
  }) => {

    if (!renewingCertification?._id || !assetRecord._id) return;
    const data = {
      lastReceivedOn: new Date(values.lastInspectionDate).toISOString(),
      expiryDate: new Date(values.expiryDate).toISOString(),
      ...(values.document?.rawFile && { document: values.document }),
    };

    try {

      await xgacDataProvider.update('user-certifications', {
        id: renewingCertification._id,
        data,
        previousData: renewingCertification,
        meta: {
          assetId: assetRecord._id,
          certificationId: renewingCertification._id,
        },
      });
      notify('ra.notification.updated', {
        type: 'success',
        messageArgs: { smart_count: 1 },
      });
      refresh();

    } catch {

      notify('ra.notification.http_error', {
        type: 'warning',
      });

    }
    closeRenewDialog();

  };

  const handlePlanRenewalSubmit = async (values: {
    plannedRenewalDate: string;
  }) => {

    const data = {
      plannedRenewalDate: new Date(values.plannedRenewalDate).toISOString(),
    };

    if (!renewingCertification?._id || !assetRecord._id) return;

    try {

      await xgacDataProvider.update('user-certifications', {
        id: renewingCertification._id,
        data,
        previousData: renewingCertification,
        meta: {
          assetId: assetRecord._id,
          certificationId: renewingCertification._id,
        },
      });
      notify('ra.notification.updated', {
        type: 'success',
        messageArgs: { smart_count: 1 },
      });
      refresh();

    } catch {

      notify('ra.notification.http_error', {
        type: 'warning',
      });

    }
    closeRenewDialog();

  };

  return (
    <>
      <Typography variant="h6" gutterBottom marginTop={'10px'}>
        {translate('resources.assets.certifications.text.sub_title')}
      </Typography>
      <Toolbar
        sx={{
          width: '100%',
          justifyContent: 'flex-end',
        }}
      >
        <CreateButton
          resource="user-certifications"
          label="resources.assets.certifications.text.add_certification"
          to={`/assets/${(assetRecord._id)}/certifications/create`}
          size="medium"
        />
      </Toolbar>
      <ArrayField source="certifications">
        <Datagrid
          rowClick={false}
          bulkActionButtons={false}
        >
          <ReferenceField source="certificationCategory._id" reference="certification-categories" label="general.fields.name" />
          {hasAtLeastOneDocumentaryProof && (
            <DocumentaryProofField source="certificationCategory._id" label="resources.assets.certifications.fields.documentary_proof" />
          )}
          <DateField source="firstIssuedOn" label="resources.assets.certifications.fields.first_issued_on" />
          <DateField source="lastReceivedOn" label="resources.assets.certifications.fields.last_received_on" />
          <CertificationExpiryField categoriesById={categoriesById} label="resources.assets.certifications.fields.expiry_date" />
          <DateFieldNullable
            source="plannedRenewalDate"
            label="resources.assets.certifications.fields.planned_renewal_date"
            neverText="general.text.none"
          />
          <CertificationListRowActions
            assetRecord={assetRecord}
            onRenew={(certification: AssetCertification & { certificationCategory?: CertificationCategory }) => {

              setRenewingCertification(certification);
              setRenewDialogOpen(true);

            }}
          />
        </Datagrid>
        <RenewalChoiceDialog
          open={renewDialogOpen}
          onClose={() => setRenewDialogOpen(false)}
          onRenewNow={() => {

            setRenewDialogChoice('renew_now');
            setRenewDialogOpen(false);

          }}
          onPlanRenewal={() => {

            setRenewDialogChoice('plan_renewal');
            setRenewDialogOpen(false);

          }}
        />
        <RenewNowModal
          open={renewDialogChoice === 'renew_now'}
          onClose={closeRenewDialog}
          onBack={() => {

            setRenewDialogChoice('closed');
            setRenewDialogOpen(true);

          }}
          hasDocumentaryProofField={categoriesById.get(renewingCertification?.certificationCategory?._id ?? '')?.isDocumentaryProofRequired}
          timeGranularity={categoriesById.get(renewingCertification?.certificationCategory?._id ?? '')?.validityPeriod}
          startDateLabel="resources.assets.certifications.fields.last_received_on"
          expiryDateLabel="resources.assets.certifications.fields.expiry_date"
          helperText="resources.assets.certifications.text.renew_now_modal_helper_text"
          title="resources.assets.certifications.text.renew_now_modal_title"
          onSubmit={handleRenewNowSubmit}
        />
        <PlanRenewalModal
          open={renewDialogChoice === 'plan_renewal'}
          onClose={closeRenewDialog}
          onBack={() => {

            setRenewDialogChoice('closed');
            setRenewDialogOpen(true);

          }}
          onSubmit={handlePlanRenewalSubmit}
          dateFieldLabel="resources.assets.certifications.fields.planned_renewal_date"
          title="resources.assets.certifications.text.plan_renewal_modal_title"
        />
      </ArrayField>
    </>
  );

};

const AssetEditForm = (editProps: { setNeedsContextRefresh: SetStateAction<any> }) => {

  const record = useRecordContext();
  const [updatedAt, setUpdatedAt] = useState<Date | null>(null);
  const [userLastLoggedIn, setUserLastLoggedIn] = useState<string | null>(null);
  const [userName, setUserName] = useState<string>('');
  const identity = useGetIdentity();
  const locale = useLocaleState();
  const currentUserId = identity.data?.id;
  const translate = useTranslate();
  const groupsRequest = useGetList('asset-groups', {
    pagination: { page: 1, perPage: 1 },
    sort: { field: 'name', order: 'ASC' },
    filter: {},
    meta: {
      $select: 'name',
    },
  });
  useEffect(() => {

    if (identity.data?.id === record?.user?._id) {

      editProps.setNeedsContextRefresh(true);

    }

  }, [identity, editProps, record]);
  useEffect(() => {

    if (record?.user?._id && !userLastLoggedIn) {

      xgacDataProvider.getOne('users', { id: record.user?._id }).then((response) => {

        const lastLoggedIn = response.data?.lastActiveAt;
        setUserName(response.data?.username);
        if (lastLoggedIn) {

          const lastLoggedInString = `${translate('resources.users.fields.lastActiveAt')}: 
          ${moment(lastLoggedIn).format('DD-MM-YYYY HH:mm')} - ${moment(lastLoggedIn).locale(locale[0]).fromNow()} `;

          setUserLastLoggedIn(lastLoggedInString);

        }

      });

    }

  }, [record, locale]); // eslint-disable-line react-hooks/exhaustive-deps
  const navigate = useNavigate();
  const AssetToolBar = (props: any) => {

    return (
      <Toolbar {...props} sx={{ justifyContent: 'end', maxWidth: '1000px' }} >

        <Button label="ra.action.back" onClick={() => navigate('/assets', { replace: true })} size="medium" sx={{ marginRight: '10px' }} variant="text"/>
        {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
        {/* @ts-ignore */}
        <SaveButton icon={null} color="primary"/>
      </Toolbar>
    );

  };

  if (!record) {

    return null;

  }
  return (
    <SimpleForm toolbar={<AssetToolBar/>} sx={{ maxWidth: '1000px' }}>
      {userLastLoggedIn ? (
        <Tooltip title={userLastLoggedIn} placement={'bottom'} arrow>
          <h4 style={{ marginBottom: '10px' }}>"{record.name}" {translate('general.text.settings')}</h4>
        </Tooltip>
      ) : (
        <h4 style={{ marginBottom: '10px' }}>"{record.name}" {translate('general.text.settings')}</h4>
      )}
      <hr/>
      <Typography variant="h6" gutterBottom marginTop={'10px'}>
        {translate('resources.assets.text.properties')}
      </Typography>

      <Grid container spacing={3}>
        <Grid md={6}>
          <GrayTextInputWithUpperLabel
            source="name"
            label="general.fields.name"
            fullWidth
            validate={required()}
          />
          <GrayTextInputWithUpperLabel
            source="properties.email"
            label="resources.assets.fields.email"
            fullWidth
            validate={email()}
          />
        </Grid>
        <Grid md={6}>
          <InputLabel className="input-label">
            {translate('resources.users.fields.username')}
          </InputLabel>
          <ReferenceOneInput reference="users" target="_id" source="userId" fullWidth>
            <GrayTextInputWithUpperLabel source="username" fullWidth label="" disabled/>
          </ReferenceOneInput>
          <PhoneNumberInput source="properties.phoneNumber" fullWidth colorVariant="gray" required/>
        </Grid>
        <Grid md={12}>
          <ImageInput source="properties.image" label="resources.assets.fields.image" fullWidth>
            <ImageField source="src" title="title"/>
          </ImageInput>
        </Grid>
        {(groupsRequest.data?.length || 0) > 0 && (
          <Grid md={12}>
            <InputLabel className="input-label">
              {translate('menu.items.groups')}
            </InputLabel>
            <ReferenceArrayInput
              source="assetGroups"
              reference="asset-groups"
              label="menu.items.groups"
              fullWidth
            >
              <GrayAutocompleteArrayInputWithUpperLabel fullWidth label={false} sx={{
                '& fieldset': {
                  borderRadius: '5px',
                  border: 'none',
                },
              }}
              />
            </ReferenceArrayInput>
          </Grid>
        )}
      </Grid>
      <hr/>
      <Typography variant="h6" gutterBottom marginTop={'10px'}>
        {translate('resources.qr-templates.text.options')}
      </Typography>
      <div style={{ width: '100%' }}>
        <Grid container spacing={2} justifyContent="center">
          <Grid md={6}>
            <InputLabel className="input-label">
              {translate('resources.users.text.access_to_dashboard')}
            </InputLabel>
            <IsAdminBooleanSetterField source={''} label="resources.users.text.access_to_dashboard" changeHandler={() => {

              setUpdatedAt(new Date());

            }}/>
          </Grid>
          <Grid md={6}>
            <FormDataConsumer>
              {({ formData }) => {

                return (
                  <BooleanCheckBoxInput
                    source="available"
                    label="resources.users.text.receives_alarms"
                    disabled={!formData.properties?.phoneNumber || formData.properties?.phoneNumber === '+31'}
                    disabledText={translate('resources.app-users.text.fill_phonenumber')}
                  />
                );

              }}
            </FormDataConsumer>
          </Grid>
        </Grid>
      </div>
      <hr/>
      <Typography variant="h6" gutterBottom marginTop={'10px'}>
        {translate('general.text.actions')}
      </Typography>
      <ResetButtonPreparer updatedAt={updatedAt}/>
      <AssetDeleteButton/>
      {currentUserId === record.user._id && (
        <TwoFactorButton
          isAsset
          username={userName}
          buttonProps={{
            variant: 'contained',
            color: 'primary',
            size: 'medium',
            sx: { marginTop: '10px' },
          }}/>
      )}
      <hr style={{ marginTop: '20px' }}/>
      <CertificationList/>
      <hr/>
    </SimpleForm>
  );

};

export const AssetEdit = () => {

  const notify = useNotify();
  const refresh = useRefresh();
  const { refetch } = useGetIdentity();
  const [needsContextRefresh, setNeedsContextRefresh] = useState(false);
  const editSuccess = async () => {

    notify('resources.users.text.saving_successful');
    if (needsContextRefresh) {

      await refreshContext();
      if (refetch) {

        refetch();

      }

    }
    refresh();

  };
  return (
    <EditWithSuccess actions={false} transform={assetUserEditTransformer} mutationOptions={{ onSuccess: editSuccess }}>
      <AssetEditForm setNeedsContextRefresh={setNeedsContextRefresh}/>
    </EditWithSuccess>
  );

};

export const AssetCreate = () => {

  const notify = useNotify();
  const redirect = useRedirect();
  const [code, setCode] = useState<string | null>(null);
  const assetCreateOnSuccess = (data: any) => {

    if (data.error) {

      notify(data.message, { type: 'error' });
      return;

    }
    notify('ra.notification.created', { messageArgs: { smart_count: 1 } });
    redirect('edit', 'assets', data.id, data);

  };

  const translate = useTranslate();
  return (
    <Create
      transform={assetUserTransformer}
      actions={false}
      mutationOptions={{ meta: { needsUserCreation: true, code }, onSuccess: assetCreateOnSuccess }}
    >
      <SimpleForm>
        <RegistrationCodePicker setCode={setCode}/>
        <Typography variant="h6" gutterBottom>
          {translate('general.fields.name')}
        </Typography>
        <TextInput
          source="name"
          label="general.fields.name"
          fullWidth
          color="info"
          validate={required()}
        />
        <Typography variant="h6" gutterBottom>
          {translate('resources.assets.text.properties')}
        </Typography>
        <PhoneNumberInput
          source="properties.phoneNumber"
          label="resources.assets.fields.phoneNumber"
          fullWidth
          color="info"
          colorVariant="normal"
          required
        />
        <TextInput
          source="properties.email"
          label="resources.assets.fields.email"
          fullWidth
          validate={[email(), required()]}
          color="info"
        />
        <UsernameInput/>
        <BooleanInput source="available" label="resources.users.text.receives_alarms" name="available" defaultValue={true} defaultChecked={true}/>
        <BooleanInput label="resources.users.text.access_to_dashboard" source="isAdmin"/>
      </SimpleForm>
    </Create>
  );

};

const UserCertificationToolbar = (props: { assetId: string }) => {

  const navigate = useNavigate();

  return (
    <Toolbar sx={{ justifyContent: 'space-between', maxWidth: '1000px' }}>
      <Button label="ra.action.back" onClick={() => navigate(`/assets/${props.assetId}`, { replace: true })} size="medium" variant="text"/>
      <SaveButton />
    </Toolbar>
  );

};

const CertificationCategoryAutocomplete = () => {

  const { setValue, resetField, getValues } = useFormContext();
  const { dirtyFields } = useFormState();
  const { allChoices, isPending } = useChoicesContext();
  useEffect(() => {

    if (isPending) return;

    const existing = getValues('certificationCategory._id');

    if (dirtyFields.certificationCategory) return;
    if (existing != null && existing !== '') return;

    const first = allChoices?.[0];
    if (!first?._id) return;

    setValue('certificationCategory._id', first._id, { shouldDirty: false });
    setValue('certificationCategory', first, { shouldDirty: false });

  }, [allChoices, getValues, setValue, dirtyFields.certificationCategory, isPending]);

  return (
    <GrayAutocompleteInputWithUpperLabel
      label="resources.assets.certifications.text.title_single"
      optionText="name"
      validate={required()}
      onChange={(_value, record) => {

        setValue('certificationCategory', record);

        if (!(record as unknown as CertificationCategory)?.isDocumentaryProofRequired) {

          resetField('document');

        }

      }}
    />
  );

};

const CertificationCategoryInput = () => (
  <ReferenceInput
    source="certificationCategory._id"
    reference="certification-categories"
    sort={{ field: 'createdAt', order: 'DESC' }}
  >
    <CertificationCategoryAutocomplete />
  </ReferenceInput>
);

export const UserCertificationCreate = () => {

  const { id: assetId } = useParams();
  const translate = useTranslate();
  const notify = useNotify();
  const redirect = useRedirect();
  const { permissions, isPending } = usePermissions();

  if (!assetId || isPending) {

    return null;

  }

  // fix permissions bypass issue that is caused by the certifications create route being a nested route of the assets resource
  if (!canAccess({
    permissions,
    action: 'create',
    resource: 'user-certifications',
  })) {

    redirect(`/assets/${assetId}`);
    return null;

  }

  const OnSuccess = () => {

    notify(`${translate('resources.assets.certifications.text.title_single')} ${translate('general.text.saved').toLowerCase()}`, { type: 'success' });
    redirect(`/assets/${assetId}`);

  };

  return (
    <CreateWithSuccess
      resource="user-certifications"
      redirect={`/assets/${assetId}`}
      transform={userCertificationTransformer}
      mutationOptions={{ meta: { assetId }, onSuccess: OnSuccess }}
    >
      <SimpleForm
        toolbar={<UserCertificationToolbar assetId={assetId}/>}
        sx={{ maxWidth: '1000px' }}
      >
        <h4 style={{ marginBottom: '10px' }}>
          {translate('resources.assets.certifications.text.add_certification')}
        </h4>
        <hr/>
        <CertificationCategoryInput/>
        <GrayDateInputWithUpperLabel
          source="firstIssuedOn"
          label="resources.assets.certifications.fields.first_issued_on"
          validate={required()}
        />
        <FormDataConsumer<{ certificationCategory: CertificationCategory | undefined }>>
          {({ formData }) => {

            return (
              <ExpiryDateDisplay
                startDateSource="lastReceivedOn"
                expiryDateSource="expiryDate"
                timeGranularity={formData.certificationCategory?.validityPeriod}
                startDateLabel="resources.assets.certifications.fields.last_received_on"
                expiryDateLabel="resources.assets.certifications.fields.expiry_date"
                helperText={translate('resources.assets.certifications.text.expiry_date_input_helper_text')}
                usage="certifications"
              />
            );

          }}
        </FormDataConsumer>
        <FormDataConsumer<{ certificationCategory: CertificationCategory | undefined }>>
          {({ formData }) => {

            if (formData.certificationCategory?.isDocumentaryProofRequired) {

              return (
                <>
                  <InputLabel className="input-label">
                    {translate('resources.assets.certifications.fields.documentary_proof')}
                  </InputLabel>
                  <DocumentaryProofInputPreview
                    source="document"
                    imageStyle={{
                      height: '600px',
                      marginBottom: '10px',
                      objectPosition: 'left',
                    }}
                    pdfStyle={{
                      height: '800px', marginBottom: '10px',
                    }}
                  />
                  <CertificationDocumentInput
                    source="document"
                    label={false}
                    labelSingle={translate('resources.assets.certifications.text.drop_document_to_upload')}
                    validate={required()}
                    accept={{
                      'application/pdf': ['.pdf'],
                      'image/*': ['.jpg', '.jpeg', '.png'],
                    }}
                  />
                </>
              );

            }

            return null;

          }}
        </FormDataConsumer>
      </SimpleForm>
    </CreateWithSuccess>
  );

};

export const UserCertificationEdit = () => {

  const { id: assetId, certificationId } = useParams();
  const location = useLocation();
  const translate = useTranslate();
  const notify = useNotify();
  const redirect = useRedirect();
  const { permissions, isPending } = usePermissions();
  const [record, setRecord] = useState<AssetCertification | undefined>();
  const [assetName, setAssetName] = useState<string | undefined>();
  const [certificationCategory, setCertificationCategory] = useState<CertificationCategory | undefined>();

  useEffect(() => {

    if (!certificationId || !assetId || isPending) {

      return;

    }

    // fix permissions bypass issue that is caused by the certifications edit route being a nested route of the assets resource
    if (!canAccess({
      permissions,
      action: 'edit',
      resource: 'user-certifications',
    })) {

      redirect(`/assets/${assetId}`);
      return;

    }

    if (location.state?.record) {

      setRecord(location.state.record);

    }

    if (location.state?.assetName) {

      setAssetName(location.state.assetName);

    }

    if (!location.state?.record) {

      // Fallback to fetch the record in case it's not in the location state. This can happen when the user navigates to the page using a link.
      xgacDataProvider.getOne('user-certifications', {
        id: certificationId,
        meta: { assetId },
      }).then((response) => {

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        // user certification is not a standalone resource and therefore cannot be 'safely' typed
        setRecord(response.data as AssetCertification);

      }).catch((error) => {

        notify(error.message, { type: 'error' });
        redirect(`/assets/${assetId}`);

      });

    }

    if (!location.state?.assetName) {

      xgacDataProvider.getOne('assets', {
        id: assetId,
      }).then((response) => {

        setAssetName(response.data?.name);

      }).catch((error) => {

        notify(error.message, { type: 'error' });

      });

    }

  }, [assetId, certificationId, notify, redirect, isPending, permissions, location.state?.record, location.state?.assetName]);

  useEffect(() => {

    if (!record) {

      return;

    }

    xgacDataProvider.getOne('certification-categories', {
      id: record.certificationCategory._id,
    }).then((response) => {

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      setCertificationCategory(response.data as CertificationCategory);

    }).catch((error) => {

      notify(error.message, { type: 'error' });
      redirect(`/assets/${assetId}`);

    });

  }, [record, notify, redirect, assetId]);

  if (!assetId || !certificationId || !record) {

    return null;

  }

  const onSubmit = async (values: FieldValues) => {

    if (!record) {

      return;

    }

    try {

      const updatedCertification = userCertificationTransformer({
        ...record,
        ...values,
      });

      await xgacDataProvider.update('user-certifications', {
        id: certificationId,
        data: updatedCertification,
        previousData: record,
        meta: { assetId, certificationId },
      });

      notify(`${translate('resources.assets.certifications.text.title_single')} ${translate('general.text.updated')}`, { type: 'success' });
      redirect(`/assets/${assetId}`);

    } catch (error) {

      notify(error instanceof Error ? error.message : 'An unknown error occurred', { type: 'error' });

    }

  };

  return (
    <Form onSubmit={onSubmit} record={record}>
      <CardContent sx={{ maxWidth: '1000px' }}>
        <Stack alignItems="flex-start" spacing={2}>
          <h4 style={{ marginBottom: '10px' }}>
            {translate('resources.assets.certifications.text.edit_certification_title', { category: certificationCategory?.name, user_name: assetName ?? '' })}
          </h4>
          <hr style={{ width: '100%' }}/>
          <GrayDateInputWithUpperLabel
            source="firstIssuedOn"
            label="resources.assets.certifications.fields.first_issued_on"
            validate={required()}
            helperText={false}
          />
          <ExpiryDateDisplay
            startDateSource="lastReceivedOn"
            expiryDateSource="expiryDate"
            timeGranularity={certificationCategory?.validityPeriod}
            startDateLabel="resources.assets.certifications.fields.last_received_on"
            expiryDateLabel="resources.assets.certifications.fields.expiry_date"
            helperText={translate('resources.assets.certifications.text.expiry_date_input_helper_text')}
            usage="certifications"
          />
          <PlannedRenewalDateInputField
            label="resources.assets.certifications.fields.planned_renewal_date"
            size="small"
          />
          {certificationCategory?.isDocumentaryProofRequired && (
            <>
              <InputLabel className="input-label">
                {translate('resources.assets.certifications.fields.documentary_proof')}
              </InputLabel>
              <DocumentaryProofInputPreview
                source="document"
                existingDocumentaryProof={record.documentaryProof}
                imageStyle={{
                  height: '600px',
                  marginBottom: '10px',
                  objectPosition: 'left',
                }}
                pdfStyle={{
                  height: '800px', marginBottom: '10px',
                }}
              />
              <CertificationDocumentInput
                source="document"
                label={false}
                validate={record.documentaryProof ? undefined : required()}
                labelSingle={translate('resources.assets.certifications.text.drop_document_to_upload')}
                accept={{
                  'application/pdf': ['.pdf'],
                  'image/*': ['.jpg', '.jpeg', '.png'],
                }}
              />
            </>
          )}
        </Stack>
      </CardContent>
      <UserCertificationToolbar assetId={assetId}/>
    </Form>

  );

};
